<ng-container *ngIf="joinCostTypeCostCenterState$ | async as state">

    <div class="content-container">

        <div class="kostenart mat-elevation-z2">
            <mat-card appearance="outlined">
                <mat-card-title-group class="stickyCardTitle">
                    <mat-form-field>
                        <mat-label>{{ "app.page.cost-type-distributions.actions.search.label" | translate }}</mat-label>
                        <input #filter matInput [formControl]="searchFormControl">
                        <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="clearFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <button matSuffix mat-icon-button>
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </mat-card-title-group>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <mat-selection-list (selectionChange)="onSelectKostenart($event)" [multiple]="false">
                        <mat-list-option *ngFor="let kostenart of filteredCostTypes$ | async" [value]="kostenart">
                            {{kostenart.name}}
                        </mat-list-option>
                    </mat-selection-list>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="join-container mat-elevation-z2">
            <div class="header">
                <mat-generic-select-input
                    matTooltip="{{ 'app.page.cost-type-distributions.reference-info.label' | translate }}"
                    matTooltipPosition="after"
                    [inputFormControl]="distributionReferenceFormControl"
                    [field]="state.referenceSelectInput"
                ></mat-generic-select-input>
                <button mat-mini-fab
                        color="primary"
                        (click)="onOpenDialog()"
                        [disabled]="state.selectedCostType === null || state.selectedCostType.distributionReferenceId === null"
                        matTooltip="{{ 'app.page.cost-type-distributions.actions.add.label' | translate }}">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
            <div *ngIf="state.selectedCostType" class="table-join">
                <table mat-table
                       [dataSource]="dataSource">

                    <ng-container matColumnDef="costCenter">
                        <th mat-header-cell
                            *matHeaderCellDef>{{ "app.page.join-cost-type-cost-center.cost-center.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{state.costCenterLookupMap[element.costCenterId].name}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="contributionMarginLevel">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.page.join-cost-type-cost-center.contribution-margin-level.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{state.contributionMarginLevelLookupMap[element.contributionMarginLevelId].name}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="costingLevel">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.page.join-cost-type-cost-center.costing-level.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            {{state.costingLevelLookupMap[element.costingLevelId].name}}

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>{{ "app.page.join-cost-type-cost-center.variable.label" | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox disabled [checked]="element.variable"></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button (click)="onOpenDialog(element)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button color="warn" mat-icon-button (click)="onDeleteDistribution(element)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="state.columns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: state.columns;"></tr>
                </table>
            </div>
        </div>

    </div>

</ng-container>
